

import { LoginOpenID } from '../components/LoginOpenID';
import { setAppAuth } from '../store/appSlice';
import { useDispatch } from 'react-redux';

interface LoginPageProps {

}

export const LoginPage: React.FC<LoginPageProps> = (props) => {

    /*
    const dispatch = useDispatch();

    const setAuthToken = (token: string, expiry: number, username: string) => {
        console.log('Token received');
        dispatch( setAppAuth({token: token, expiry: expiry,username:username}));
    };
    */
    return <LoginOpenID/>
};

